import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", height = 44, to = "/", linkable = true }) {
  const img = (
    <img
      src="/brand/logo_t.png"
      alt="ProactiveBH — Pediatric Behavioral Health"
      style={{ height }}
      className={`logo-pop w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
  return linkable ? (
    <Link to={to} className="inline-flex items-center">
      {img}
    </Link>
  ) : (
    img
  );
}
